module.exports = __webpack_public_path__ + "img/checked.0c7ecae5.svg";